module.exports = __webpack_public_path__ + "static/pregnancyawareness-5a42cc964ca93726e9bac85da72b26c1.png";